
export default function( settings )
{
    const game_40_settings = {
        slot : {
            background: 'res/games/game_40/game_40_screen.png',
            underScreen: 'res/games/game_40/game_40_under_screen.png',
            underScreenPos: {x: 62, y: 123},
            barrel: {
                position : { x : 66, y : 125 },
                positions_x : [ 66, 279, 493, 706, 920 ],
                cellSize : { width : 213, height : 197 },
            },

            balls : 'game_40_ball_{symbol}_%03d.png',
            mini_balls_rotating : 'res/games/mini_balls/{symbol}_00.png',
            mini_balls_flash : 'res/games/mini_balls/{symbol}_01.png',

            roll_music: 'res/games/game_40/sounds/balls_roll_music',
            ball_away_sound: 'res/games/game_40/sounds/balls_away',
            ball_stop_sound: 'res/games/game_40/sounds/balls_end_roll',

            symbol_animation_filename_pattern : 'game_40_ball_%d',
            symbol_animation_filename_pattern_postfix : '_%03d.png',
            //animation_frames_count: 3,
            symbol_animation_sequence : [ 6, 7, 8, 7, 6 ],
            animation_frame_delay : 0.05,

            lines_pattern : 'res/games/game_40/game_40_lines/game_40_line_%d.png',
            lines_position : [
                [ 29, 409 ],//0
                [ 29, 215 ],//1
                [ 29, 605 ],//2
                [ 29, 148 ],//3
                [ 29, 209 ],//4
                [ 29, 344 ],//5
                [ 29, 175 ],//6
                [ 29, 279 ],//7
                [ 29, 279 ],//8
            ],

            lines_sound_pattern: 'res/games/sounds/lines_',//

            frames_template : 'res/games/game_40/game_40_frames/frame_%d.png',
            frames_disp : { x : -8, y : -8 },

            scatter_frame: 'res/games/game_40/game_40_frames/frame_3.png',

            left_billets_on_filename_pattern : 'res/games/game_40/game_40_billets/game_40_billet_%d.png',
            right_billets_on_filename_pattern : 'res/games/game_40/game_40_billets/game_40_billet_%d.png',
            left_billets_coords: [
                {x:4, y:391},
                {x:4, y:194},
                {x:4, y:586},
                {x:4, y:129},
                {x:4, y:650},
                {x:4, y:327},
                {x:4, y:456},
                {x:4, y:261},
                {x:4, y:521},
            ],
            right_billets_coords: [
                {x:1134, y:391},
                {x:1134, y:194},
                {x:1134, y:586},
                {x:1134, y:129},
                {x:1134, y:650},
                {x:1134, y:327},
                {x:1134, y:456},
                {x:1134, y:521},
                {x:1134, y:261},
            ],
            //systemaTextColor : 0x000000,
            terminalTextColor : 0x000000,
        },
        ui : {
            common: {
                font:'yello_dig',
            },
            buttons: {
                spin: {
                    frames:{
                        normal : 'game_40_result_on.png',
                        disabled : 'game_40_result_off.png',
                    },
                    position:{x : 1443, y : 759 },
                },
                collect: {
                    frames:{
                        normal : 'game_40_result_on.png',
                        disabled : 'game_40_result_off.png',
                    },
                    position:{x : 1443, y : 759 },
                },
                start: {
                    frames:{
                        normal : 'game_40_autoplay_on.png',
                        disabled : 'game_40_autoplay_off.png',
                    },
                    position:{ x : 1318, y : 759 },
                },
                finish: {
                    frames:{
                        normal : 'game_40_result_on.png',
                        disabled : 'game_40_result_off.png',
                    },
                    position:{x : 1443, y : 759 },
                },
                info: {
                    frames:{
                        normal : 'game_40_info_on.png',
                        disabled : 'game_40_info_off.png',
                    },
                    position:{x : 1054, y : 6 },
                },
                sound_on: {
                    frames:{
                        normal : 'game_40_sound_off.png',
                        disabled : 'game_40_sound_on.png',
                    },
                    position:{x : 1055, y : 62}
                },
                sound_off: {
                    frames:{
                        normal : 'game_40_sound_on.png',
                        disabled : 'game_40_sound_off.png',
                    },
                    position:{x : 1055, y : 62}
                },
                gamble: {
                    frames:{
                        normal : 'game_40_autoplay_on.png',
                        disabled : 'game_40_autoplay_off.png',
                    },
                    position:{ x : 1318, y : 759 },
                },
                betmax: {
                    frames:{
                    },
                    position:{ x : 0, y : 0 },
                },
                betmin: {
                    frames:{
                    },
                    position:{ x : 0, y : 0 },
                },
                autoplay: {
                    frames:{
                        normal : 'game_40_autoplay_on.png',
                        disabled : 'game_40_autoplay_off.png',
                    },
                    position:{ x : 1318, y : 759 },
                },
                autoplayoff: {
                    frames:{
                        normal : 'game_40_autoplay_stop.png',
                        disabled : 'game_40_autoplay_off.png',
                    },
                    position:{ x : 1318, y : 759 },
                },
                menu: {
                    frames:{
                        normal : 'game_40_menu_on.png',
                        disabled : 'game_40_menu_off.png',
                    },
                    position:{ x : 1192, y : 760 }
                },
                decrease_lines: {
                    frames:{
                    },
                    position:{ x : 0, y : 0 },
                },
                increase_lines: {
                    frames:{
                    },
                    position:{ x : 0, y : 0 },
                },
                lines: {
                    frames:{
                    },
                    position:{ x : 0, y : 0 },
                },
                decrease_linebet: {
                    frames:{
                    },
                    position:{ x : 0, y : 0 },
                },
                increase_linebet: {
                    frames:{
                    },
                    position:{ x : 0, y : 0 },
                },
                linebet: {
                    frames:{
                        normal : 'game_40_size_step_on.png',
                        disabled : 'game_40_size_step_off.png',
                    },
                    position:{ x : 1192, y : 820 },
                },
                next: {
                    frames: {
                        normal : 'game_40_help_next_on.png',
                        disabled : 'game_40_help_next_off.png',
                    },
                    position:{ x : 789, y : 809 },
                },
                exit: {
                    frames: {
                        normal : 'game_40_help_exit_on.png',
                        disabled : 'game_40_help_exit_off.png',
                    },
                    position:{ x : 23, y : 809 },
                },
                back: {
                    frames: {
                        normal : 'game_40_help_back_on.png',
                        disabled : 'game_40_help_back_off.png',
                    },
                    position:{ x : 660, y : 809 },
                },
                visual_mode : {
                    frames : {
                        normal : 'game_40_visual_mode_on.png',
                        disabled : 'game_40_visual_mode_off.png',
                    },
                    position : { x : 0, y : 702 },
                },

                risk_red: {
                    frames:{
                        normal : 'game_40_risk_red_on.png',
                        disabled : 'game_40_risk_red_off.png',
                    },
                    position:{ x : 1192, y : 759 }
                },
                risk_black: {
                    frames:{
                        normal : 'game_40_risk_black_on.png',
                        disabled : 'game_40_risk_black_off.png',
                    },
                    position:{ x : 1192, y : 820 },
                },

                end_pari: {
                    frames:{
                        normal : 'game_40_exit_pari_on.png',
                        disabled : 'game_40_exit_pari_off.png',
                    },
                    position:{x: 8, y : 8 },
                },
            },
            frames: {
                lines:{
                    text_position:{ x : 0, y : 0 },
                    text_align : { x : 1.0, y : 0.0 },
                    position : { x : 1161, y : 776 },
                },
                line_bet:{
                    text_position:{ x : 0, y : 0 },
                    text_align : { x : 1.0, y : 0.0 },
                    position : { x : 1161, y : 805 },
                },
                win:{
                    text_position:{ x : 0, y : 0 },
                    text_align : { x : 1.0, y : 0.0 },
                    position : { x : 1161, y : 860 }
                },
                total_bet:{
                    text_position:{ x : 0, y : 0 },
                    text_align : { x : 1.0, y : 0.0 },
                    position : { x : 1161, y : 833 }
                },
                risk_step:{
                    text_position:{ x : 0, y : 0 },
                    text_align : { x : 1.0, y : 0.0 },
                    position : { x : 1161, y : 833 }
                },
                risk_win:{
                    text_position:{ x : 0, y : 0 },
                    text_align : { x : 1.0, y : 0.0 },
                    position : { x : 1161, y : 860 }
                },
                free_win: {
                    frame:'res/games/ui/free_result.png',
                    text_position:{x:213, y:11},
                    text_align:{x:1.0, y:0.5},
                    position:{x:11, y:855}
                },
                free_step_win: {
                    text_position:{ x : 0, y : 0 },
                    text_align : { x : 1.0, y : 0.0 },
                    position : { x : 1161, y : 860 }
                }
                //TODO: минимальный шаг:
                /*min_step:{
                    //font: 'userinterface_win-font',
                    text_position:{x:44, y:37},
                    text_align:{x:0.5, y:0.5},
                    position:{x:469, y:699}
                },*/
            },
        },
        risk : {
            background : 'res/games/game_40/game_40_risk_screen.png',
            background_position : { x : 0, y : 121 },
            table_background: 'res/games/game_40/game_40_risk_table_screen.png',
            table_background_position: { x : 0, y : 121 },
            currentWinLabel : {
                font : '40_risk_result_font',
                position : { x : 120, y : 243 },
                align : 'left',
            },
            nextWinLabel : {
                font : '40_risk_result_font',
                position : { x : 960, y : 243 },
                align : 'left',
            },
            currentStepLabel: {
                font : 'risk_step_font',
                position : { x : 895, y : 30 + 126 },
                align : 'central',
            },
            stepsLabel: {
                font : 'risk_step_font',
                position : { x : 989, y : 30 + 126 },
                align : 'central',
            },
            centralCard : {
                redShirt : 'game_40_shirt_red.png',
                blackShirt : 'game_40_shirt_blue.png',
                position : { x : 503, y : 274 + 121 },
            },
            redButton : {
                state : {
                    normal : 'game_40_red_button_on.png',
                    over : 'game_40_red_button_on.png',
                    pressed : 'game_40_red_button_on.png',
                    disabled : 'game_40_red_button_off.png',
                },
                position : { x : 178, y : 316 + 121 },
            },
            blackButton : {
                state : {
                    normal : 'game_40_black_button_on.png',
                    over : 'game_40_black_button_on.png',
                    pressed : 'game_40_black_button_on.png',
                    disabled : 'game_40_black_button_off.png',
                },
                position : { x : 832, y : 316 + 121 },
            },
            history : {
                length : 6,
                suits : [
                    'game_40_red_mini.png',
                    'game_40_red_mini.png',
                    'game_40_black_mini.png',
                    'game_40_black_mini.png',
                ],
                cardScale : 1,
                position : { x : 319, y : 289 },
                cardOffset : 95 - 1,
            },
            suits : [
                'game_40_card_red.png',
                'game_40_card_red.png',
                'game_40_card_black.png',
                'game_40_card_black.png',
            ],
            check : 'res/games/game_40/risk/risk_check.png',
            light_plates: {
                name: 'res/games/game_40/risk/light_part.png',
                //координаты относительно table_background
                x: 72,
                y: [190, 327],
            },
            tableCurrentStepLabel: {
                font : 'risk_table_step_font',
                position : { x : 797, y : 98 + 121 },
                align : 'central',
            },
            tableStepsLabel: {
                font : 'risk_table_step_font',
                position : { x : 865, y : 98 + 121 },
                align : 'central',
            },
            win_sound: 'res/games/sounds/risk_win',
            lose_sound: 'res/games/sounds/risk_lose',
            blink_sound: 'res/games/sounds/card_blink',
        },

        help : {
            pages: 35,
            pageNameFormat: "res/games/game_40/help/page_%03d.jpg",
            terminalTextColor : 0xffd580,
            terminal_position: {x: 1195, y: 843},
            paging_sound: 'res/games/sounds/help_paging',
        },

        cheque : {
            pari : '094099421747',
            event : '«Событие M15»',
            freegame_event : '«Событие M16»',
        },

        table : {
            background : 'res/games/game_40/big_ticket/game_40_screen_ticket.png',
            background_position: {x: 0, y: 119},
            combinationNameFormat : 'res/games/game_40/big_ticket/game_40_comby%02d.png',
            coloursCircleNameFormat : 'game_40_check_ball_%d.png',
            scatterCircleName : 'game_40_check_ball_3.png',
            frameNameFormat : 'game_40_table_frame_%d.png',
            scatterFrameName : 'game_40_table_frame_3.png',
            frameYPos : [ 211, 285, 359, 418, 477, 536, 595 ],
            scatterPrice: {
                wins:[2,3,4,5],
                position:{x:937, y:214}
            },
            priceTable: [
                {
                    symbol:1,
                    wins:[2,3,4,5],
                    position:{x:1124, y:214}
                },
                {
                    symbol:2,
                    wins:[2,3,4,5],
                    position:{x:937, y:287}
                },
                {
                    symbol:3,
                    wins:[2,3,4,5],
                    position:{x:1124, y:287}
                },
                {
                    symbol:4,
                    wins:[3,4,5],
                    position:{x:937, y:362}
                },
                {
                    symbol:5,
                    wins:[3,4,5],
                    position:{x:1124, y:362}
                },
                {
                    symbol:6,
                    wins:[3,4,5],
                    position:{x:937, y:421}
                },
                {
                    symbol:7,
                    wins:[3,4,5],
                    position:{x:1124, y:421}
                },
                {
                    symbol:8,
                    wins:[3,4,5],
                    position:{x:937, y:481}
                },
                {
                    symbol:9,
                    wins:[3,4,5],
                    position:{x:1124, y:481}
                },
                {
                    symbol:10,
                    wins:[3,4,5],
                    position:{x:937, y:539}
                },
                {
                    symbol:11,
                    wins:[3,4,5],
                    position:{x:1124, y:539}
                },
                {
                    symbol:12,
                    wins:[2,3,4,5],
                    position:{x:937, y:598}
                },
            ]
        },
        smallTicket : {
            balls_screen : 'game_40_balls_screen.png',
            miniballsNameFormat : 'game_40_mb%02d.png',
            scatterBallName : 'game_40_mb03.png',
            lines_choice : 'game_40_small_table_line_%02d.png',
            risk_template : 'game_40_risk_screen%02d.png',
        },
        texts: {
            imgMain: 'res/games/game_40/screen_text/game_40_game_text.png',
            posMain: {x: 1210, y: 119},
            imgRisk: 'res/games/game_40/screen_text/game_40_risk_text.png',
            posRisk: {x: 1210, y: 119},
        }
    }

    return {
        //settings можно смело модифицировать - он копируется для каждой игры из шаблона:
        settings: game_40_settings,

        //name для удобства чтения логов на сервере:
        name : 'game_40',
        //идентификатор математики на сервере:
        id : 583,

        reactive,

        graphics : [

            //freegames:
            // 'res/games/freegames/finish.png',
            // 'res/games/freegames/start.png',
            // 'res/games/freegames/win_table_nums.xml',

            //small ticket:
            'res/games/game_40/game_40_small_table.json',

            //help:
            'res/games/game_40/help/page_000.jpg',
            'res/games/game_40/help/page_001.jpg',
            'res/games/game_40/help/page_002.jpg',
            'res/games/game_40/help/page_003.jpg',
            'res/games/game_40/help/page_004.jpg',
            'res/games/game_40/help/page_005.jpg',
            'res/games/game_40/help/page_006.jpg',
            'res/games/game_40/help/page_007.jpg',
            'res/games/game_40/help/page_008.jpg',
            'res/games/game_40/help/page_009.jpg',
            'res/games/game_40/help/page_010.jpg',
            'res/games/game_40/help/page_011.jpg',
            'res/games/game_40/help/page_012.jpg',
            'res/games/game_40/help/page_013.jpg',
            'res/games/game_40/help/page_014.jpg',
            'res/games/game_40/help/page_015.jpg',
            'res/games/game_40/help/page_016.jpg',
            'res/games/game_40/help/page_017.jpg',
            'res/games/game_40/help/page_018.jpg',
            'res/games/game_40/help/page_019.jpg',
            'res/games/game_40/help/page_020.jpg',
            'res/games/game_40/help/page_021.jpg',
            'res/games/game_40/help/page_022.jpg',
            'res/games/game_40/help/page_023.jpg',
            'res/games/game_40/help/page_024.jpg',
            'res/games/game_40/help/page_025.jpg',
            'res/games/game_40/help/page_026.jpg',
            'res/games/game_40/help/page_027.jpg',
            'res/games/game_40/help/page_028.jpg',
            'res/games/game_40/help/page_029.jpg',
            'res/games/game_40/help/page_030.jpg',
            'res/games/game_40/help/page_031.jpg',
            'res/games/game_40/help/page_032.jpg',
            'res/games/game_40/help/page_033.jpg',
            'res/games/game_40/help/page_034.jpg',

            //risk:

            'res/games/game_40/game_40_risk_screen.png',
            'res/games/game_40/for_ball_risk.png',
            'res/games/game_40/game_40_risk.json',
            'res/games/game_40/game_40_risk_table_screen.png',
            'res/games/game_40/risk/40_risk_result_font.xml',
            'res/games/game_40/risk/light_part.png',
            'res/games/game_40/risk/risk_check.png',

            'res/games/risk/risk_step_font.xml',
            'res/games/risk/risk_table_ball_red.png',
            'res/games/risk/risk_table_ball_black.png',
            'res/games/risk/risk_table_step_font.xml',

            //table:
            'res/games/game_40/big_ticket/game_40_screen_ticket.png',
            // 'res/games/table/coeff_tab_digits.xml',
            'res/games/game_40/big_ticket/game_40_comby00.png',
            'res/games/game_40/big_ticket/game_40_comby01.png',
            'res/games/game_40/big_ticket/game_40_comby02.png',
            'res/games/game_40/big_ticket/game_40_comby03.png',
            'res/games/game_40/big_ticket/game_40_comby04.png',
            'res/games/game_40/game_40_ticket.json',
            //cheque:
            'res/games/game_40/game_40_check.png',
            // 'res/games/cheque/digits_ishod.xml',

            //ui:
            'res/games/game_40/game_40_buttons.json',

            //main game
            'res/games/game_40/game_40_screen.png',
            'res/games/game_40/game_40_under_screen.png',
            'res/games/game_40/screen_text/game_40_game_text.png',
            'res/games/game_40/screen_text/game_40_risk_text.png',

            'res/games/game_40/game_40_billets/game_40_billet_0.png',
            'res/games/game_40/game_40_billets/game_40_billet_1.png',
            'res/games/game_40/game_40_billets/game_40_billet_2.png',
            'res/games/game_40/game_40_billets/game_40_billet_3.png',
            'res/games/game_40/game_40_billets/game_40_billet_4.png',
            'res/games/game_40/game_40_billets/game_40_billet_5.png',
            'res/games/game_40/game_40_billets/game_40_billet_6.png',
            'res/games/game_40/game_40_billets/game_40_billet_7.png',
            'res/games/game_40/game_40_billets/game_40_billet_8.png',

            'res/games/game_40/game_40_frames/frame_0.png',
            'res/games/game_40/game_40_frames/frame_1.png',
            'res/games/game_40/game_40_frames/frame_2.png',
            'res/games/game_40/game_40_frames/frame_3.png',
            'res/games/game_40/game_40_frames/frame_4.png',
            'res/games/game_40/game_40_frames/frame_5.png',
            'res/games/game_40/game_40_frames/frame_6.png',
            'res/games/game_40/game_40_frames/frame_7.png',
            'res/games/game_40/game_40_frames/frame_8.png',

            'res/games/game_40/game_40_lines/game_40_line_0.png',
            'res/games/game_40/game_40_lines/game_40_line_1.png',
            'res/games/game_40/game_40_lines/game_40_line_2.png',
            'res/games/game_40/game_40_lines/game_40_line_3.png',
            'res/games/game_40/game_40_lines/game_40_line_4.png',
            'res/games/game_40/game_40_lines/game_40_line_5.png',
            'res/games/game_40/game_40_lines/game_40_line_6.png',
            'res/games/game_40/game_40_lines/game_40_line_7.png',
            'res/games/game_40/game_40_lines/game_40_line_8.png',

            'res/games/game_40/game_40_for_balls.png',
            'res/games/game_40/game_40_a1_a15.png',
            //потом займёмся упаковкой и прочим ;) (думаю даже вообще удастся как-то свести все эти игры под одну с маленькими отличиями) ...
            'res/games/mini_balls/0_00.png',
            'res/games/mini_balls/0_01.png',
            'res/games/mini_balls/0_02.png',
            'res/games/mini_balls/1_00.png',
            'res/games/mini_balls/1_01.png',
            'res/games/mini_balls/1_02.png',
            'res/games/mini_balls/2_00.png',
            'res/games/mini_balls/2_01.png',
            'res/games/mini_balls/2_02.png',
            'res/games/mini_balls/3_00.png',
            'res/games/mini_balls/3_01.png',
            'res/games/mini_balls/3_02.png',
            'res/games/mini_balls/4_00.png',
            'res/games/mini_balls/4_01.png',
            'res/games/mini_balls/4_02.png',
            'res/games/mini_balls/5_00.png',
            'res/games/mini_balls/5_01.png',
            'res/games/mini_balls/5_02.png',
            'res/games/mini_balls/6_00.png',
            'res/games/mini_balls/6_01.png',
            'res/games/mini_balls/6_02.png',
            'res/games/mini_balls/7_00.png',
            'res/games/mini_balls/7_01.png',
            'res/games/mini_balls/7_02.png',
            'res/games/mini_balls/8_00.png',
            'res/games/mini_balls/8_01.png',
            'res/games/mini_balls/8_02.png',
            'res/games/mini_balls/9_00.png',
            'res/games/mini_balls/9_01.png',
            'res/games/mini_balls/9_02.png',
            'res/games/mini_balls/10_00.png',
            'res/games/mini_balls/10_01.png',
            'res/games/mini_balls/10_02.png',
            'res/games/mini_balls/11_00.png',
            'res/games/mini_balls/11_01.png',
            'res/games/mini_balls/11_02.png',
            'res/games/mini_balls/12_00.png',
            'res/games/mini_balls/12_01.png',
            'res/games/mini_balls/12_02.png',
            'res/games/mini_balls/black_01.png',
            'res/games/mini_balls/red_01.png',

            'res/games/game_40/game_40_balls_0.json',
            'res/games/game_40/game_40_balls_1.json',
            'res/games/game_40/game_40_balls_2.json',
            'res/games/game_40/game_40_balls_3.json',
            'res/games/game_40/game_40_balls_4.json',

            //common:
            'res/games/preloader.png',
        ],
        sounds : [
            'res/games/game_40/sounds/balls_away',
            'res/games/game_40/sounds/balls_end_roll',
            'res/games/game_40/sounds/balls_roll_music',
            'res/games/game_40/sounds/win/bell100',
            'res/games/game_40/sounds/win/bell500',
            'res/games/game_40/sounds/win/bell1000',
            'res/games/game_40/sounds/win/win_line_4',
            'res/games/game_40/sounds/win/win_line_5',
        ],
    }
}

function reactive( { space, container }, spec ) {
    //тут можно изменять space типа space.s( 'stream' ).alter() или добавлять что-то в container ...


    const win_sounds = [];
    win_sounds.push(sounds.get('res/games/game_40/sounds/win/win_line_4'));
    win_sounds.push(sounds.get('res/games/game_40/sounds/win/win_line_5'));

    const bell_sounds = [];
    bell_sounds.push(sounds.get('res/games/game_40/sounds/win/bell100'));
    bell_sounds.push(sounds.get('res/games/game_40/sounds/win/bell500'));
    bell_sounds.push(sounds.get('res/games/game_40/sounds/win/bell1000'));

    const getWinSound = (line, math) =>  {
        const winPosition = math.lineWinPositions(line);

        if (!winPosition) return null;

        let winSymbolsCount = 0;
        let hasWild = false;
        for (let i = 0; i < winPosition.length; ++i) {
            if (winPosition[i] !== null && winPosition[i] !== undefined) {
                if (math.slotSymbols()[winPosition[i]] === math.wild) {
                    hasWild = true;
                }
                winSymbolsCount++;
            }
        }

        if (winSymbolsCount > 3) {
            return win_sounds[1]
        }
        else {
            return win_sounds[0]
        }
    };

    space.s( 'presenter:play_line' )
        .with(space.s('presenter:show_first_time'), (line_order, atFirst) => {
            if (atFirst && line_order >= 0) {
                return line_order
            }
            else {
                return -1
            }
        })
        .filter(line_order => line_order >= 0)
        .with(space.s('math'), space.s('ui:price'), (line, math, bet) => ({line, math, bet}))
        .on(({line, math, bet}) => {
            let lineNumber = math.winLines()[line];
            let snd = getWinSound(lineNumber, math);
            if (snd) {
                snd.play();
            }

            let lineWin = math.lineWin(line) / bet;
            if (lineWin >= 1000) {
                bell_sounds[2].play();
            }
            else {
                if (lineWin >= 500) {
                    bell_sounds[1].play();
                }
                else {
                    if (lineWin >= 100){
                        bell_sounds[0].play();
                    }
                }
            }
        });

    space.s( 'presenter:play_scatters' )
        .with(space.s('presenter:show_first_time'), (scatter, atFirst) => scatter && atFirst)
        .filter(play => play)
        .with(space.s('math'), (_, math) => math)
        .on(math => {
            if (math.scatterWin() > 0) {
                const scatterCount = math.scatterCount();
                if (scatterCount > 2) {
                    win_sounds[1].play();
                }
                else {
                    win_sounds[0].play();
                }
            }
        })

}






// WEBPACK FOOTER //
// ./src/games/game_40.es6